<!-- MARK: Verification Overlay -->
@if (showTurnstileOverlay()) {
  <div class="verification-overlay">
    <div class="verification-modal">
      <h2>Please Verify to Continue</h2>
      <div class="verification-wrapper">
        <ngx-turnstile [siteKey]="turnstileSiteKey" [theme]="(userSettingsService.userTheme$ | async) === 'albion-dark-theme' ? 'dark' : 'light'" (resolved)="onTurnstileResponse($event)" (errored)="onTurnstileError($event)"></ngx-turnstile>
      </div>
      <p class="verification-warning">This helps us prevent abuse and keep the service running smoothly</p>
    </div>
  </div>
}

<app-section sectionTitle="YOUR SUBSCRIPTIONS">
  @if (afmbe.afmStripeUserData().customers.length > 0) {
    <p>Stripe creates one customer ID for each currency you use. That's why you may see more than one customer.</p>
    <p>
      If you have any trouble managing or cancelling your subscription, don't hesitate to get in touch.
      <a href="https://discord.com/invite/BPmDE3zznH" target="_blank">Discord</a> is the fastest way to get help. You can also check the <a routerLink="/feedback">Feedback</a> page for other options.
    </p>
    <div class="main-container">
      @for (customer of afmbe.afmStripeUserData().customers; track $index) {
        <div class="customer-details">
          <div matTooltip="Manage You Subscriptions" class="detail-item">
            <button style="width: 120px; height: 60px" mat-flat-button color="accent" (click)="getPortalSession(customer.id)" [disabled]="isLoadingPortal()" aria-label="Manage Subscription Button">Manage/Cancel Subscription</button>
          </div>
          <div class="detail-item">
            <div class="title">Customer Name</div>
            <div>{{ getInitials(customer.name ?? '') }}</div>
          </div>
          <div class="detail-item">
            <div class="title">Currency</div>
            <div>{{ customer.currency ?? '-' }}</div>
          </div>
          <div class="detail-item">
            <div class="title">Email</div>
            <div>{{ privatizeEmail(customer.email ?? '') }}</div>
          </div>
          <div class="detail-item">
            <div class="title">Balance</div>
            <div>{{ -(customer.balance / 100) | number: '1.2-2' }}</div>
          </div>
        </div>
        @if (getSubscriptionsForCustomer(customer.id).length > 0) {
          @for (sub of getSubscriptionsForCustomer(customer.id); track $index) {
            @for (subItem of sub.items.data; track $index) {
              @if (afmbe.getLoadedProductById(subItem.price.product.toString()); as subProduct) {
                <div class="subscription-details">
                  <div class="detail-item">
                    <div class="title">Subscription</div>
                    <div>{{ subProduct.product.name }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="title">Status</div>
                    <div>{{ sub.status }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="title">Price</div>
                    <div>{{ subItem.price.currency }} {{ (subItem.price.unit_amount ?? 0) / 100 | number: '1.2-2' }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="title">Start Date</div>
                    <div>{{ sub.start_date * 1000 | date }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="title">Monthly End</div>
                    <div>{{ sub.current_period_end * 1000 | date }}</div>
                    @if (!sub.cancel_at) {
                      <div style="text-align: center">This is the next charge date</div>
                    }
                  </div>
                  @if (sub.cancel_at) {
                    <div class="detail-item">
                      <div class="title">Will Cancel On</div>
                      <div>{{ sub.cancel_at * 1000 | date }}</div>
                    </div>
                  }
                </div>
              }
            }
          }
        } @else {
          <p class="subscription-details">No subscriptions under this customer.</p>
        }
      }
    </div>
  } @else {
    <p>You have no active subscriptions.</p>
  }
</app-section>
